import type { Ref } from 'vue'
import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import { LOYALTY_ACCOUNT_QUERY_KEY } from '../queries'
import type { DeleteLoyaltyAccountPayload } from '@/modules/Profile/types/api/payload/loyaltyAccount'
import type { DeleteLoyaltyAccountSuccessResponse } from '@/modules/Profile/types/api/response/loyaltyAccount'
import { axiosInstance } from '@/modules/Core/plugins/axios'

const ENDPOINT = '/LoyaltyAccount'

export function deleteLoyaltyAccount({
  supplierCode,
  supplierType,
  familyNumber,
}: DeleteLoyaltyAccountPayload) {
  return axiosInstance
    .delete<DeleteLoyaltyAccountSuccessResponse>(ENDPOINT, {
      data: {
        supplierCode,
        supplierType,
        familyNumber,
      },
    })
    .then((response) => response)
}

export function useDeleteLoyaltyAccountMutation(
  type: Ref<string>,
  options?: UseMutationOptions<
    AxiosResponse<DeleteLoyaltyAccountSuccessResponse>,
    AxiosCustomError,
    DeleteLoyaltyAccountPayload,
    any
  >
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: DeleteLoyaltyAccountPayload) =>
      deleteLoyaltyAccount(payload),
    async onSuccess() {
      await queryClient.invalidateQueries([LOYALTY_ACCOUNT_QUERY_KEY, type])
    },
    ...options,
  })
}
